<template>
  <div style="padding: 20px">
    <div style="display:flex;">
      <div style="margin-bottom: 20px">
        <el-input v-model="query.coachName" placeholder="教练姓名" style="width: 160px;"/>
        <el-select style="width: 140px;margin: 0 10px"
                   v-model="query.coachType"
                   placeholder="教练类型"
                   clearable>
          <el-option key="1" label="全职" :value="1"></el-option>
          <el-option key="0" label="兼职" :value="0"></el-option>
        </el-select>
        <el-select style="width: 150px" v-model="query.regionId" placeholder="多选城市"
                   class="handle-select mr10">
          <el-option
              v-for="(item,index) in regionList" :key="index"
              :label="item.regionName"
              :value="item.regionId"></el-option>
        </el-select>
        <el-date-picker
            v-model="query.yearAndMonth"
            type="month"
            style="width: 170px;"
            value-format="YYYY-MM"
            placeholder="日期选择">
        </el-date-picker>
        <el-button
            type="primary"
            style="margin-left: 10px"
            @click="selectTableData"
        >搜索
        </el-button>
        <el-popconfirm @confirm="exportFile" title="确定要导出吗？">
          <template #reference>
            <el-button v-permission="['CoachMonthFee:export']" type="primary">导出</el-button>
          </template>
        </el-popconfirm>
      </div>
    </div>
    <el-table
        :data="tableData"
        border
        v-loading="tableLoading"
        height="606px"
        ref="multipleTable"
        :row-style="{ height: '15px' }"
        :cell-style="{ padding: '14px' }"
        header-cell-class-name="table-header"
    >
      <!-- 城市 -->
      <el-table-column label="城市" min-width="120" show-overflow-tooltip>
        <template #default="{ row }">
          {{ row.cityName }}
        </template>
      </el-table-column>

      <!-- 姓名 -->
      <el-table-column label="姓名" min-width="130" show-overflow-tooltip>
        <template #default="{ row }">
          {{ row.coachName }}
        </template>
      </el-table-column>

      <!-- 角色 -->
      <el-table-column label="角色" min-width="100" show-overflow-tooltip>
        <template #default="{ row }">
          {{ row.coachType }}
        </template>
      </el-table-column>

      <!-- 常规课时单价 -->
      <el-table-column label="常规课时单价" min-width="130" align="right">
        <template #default="{ row }">
          {{ row.classUnit }}
        </template>
      </el-table-column>

      <!-- 1h课时单价 -->
      <el-table-column label="1h课时单价" min-width="130" align="right">
        <template #default="{ row }">
          {{ row.oneUnit }}
        </template>
      </el-table-column>

      <!-- 1.5h课时单价 -->
      <el-table-column label="1.5h课时单价" min-width="140" align="right">
        <template #default="{ row }">
          {{ row.oneHalfUnit }}
        </template>
      </el-table-column>

      <!-- 2h课时单价 -->
      <el-table-column label="2h课时单价" min-width="130" align="right">
        <template #default="{ row }">
          {{ row.twoUnit }}
        </template>
      </el-table-column>

      <!-- 校区 -->
      <el-table-column label="校区" min-width="160" show-overflow-tooltip align="left">
        <template #default="{ row }">
          {{ row.areaName }}
        </template>
      </el-table-column>

      <!-- 效比完成率 -->
      <el-table-column label="效比完成率" min-width="130" align="right">
        <template #default="{ row }">
          {{ row.areaRatio }}
        </template>
      </el-table-column>

      <!-- 课程类型 -->
      <el-table-column label="课程类型" min-width="300">
        <template #default="scope">
          <div style="display: flex;flex-wrap:wrap;gap:8px;">
            <el-tag v-for="(item,index) in scope.row.mapCourse" :key="index">
              {{item.ctype}} - {{item.ctypeNum}}
            </el-tag>
          </div>
        </template>
      </el-table-column>

      <!-- 后面所有列都统一加上 min-width 即可 -->
      <el-table-column label="常规课时总数" min-width="140" align="right">
        <template #default="{ row }">{{ row.classCount }}</template>
      </el-table-column>
      <el-table-column label="常规课时费" min-width="120" align="right">
        <template #default="{ row }">{{ row.classMoney }}</template>
      </el-table-column>
      <el-table-column label="1h课时总数" min-width="130" align="right">
        <template #default="{ row }">{{ row.oneCount }}</template>
      </el-table-column>
      <el-table-column label="1h课时费" min-width="120" align="right">
        <template #default="{ row }">{{ row.oneMoney }}</template>
      </el-table-column>
      <el-table-column label="1.5h课时总数" min-width="140" align="right">
        <template #default="{ row }">{{ row.oneHalfCount }}</template>
      </el-table-column>
      <el-table-column label="1.5h课时费" min-width="130" align="right">
        <template #default="{ row }">{{ row.oneHalfMoney }}</template>
      </el-table-column>
      <el-table-column label="2h课时总数" min-width="130" align="right">
        <template #default="{ row }">{{ row.twoCount }}</template>
      </el-table-column>
      <el-table-column label="2h课时费" min-width="120" align="right">
        <template #default="{ row }">{{ row.twoMoney }}</template>
      </el-table-column>
      <el-table-column label="固定课时总数" min-width="130" align="right">
        <template #default="{ row }">{{ row.fixCount }}</template>
      </el-table-column>
      <el-table-column label="固定课时费" min-width="120" align="right">
        <template #default="{ row }">{{ row.fixMoney }}</template>
      </el-table-column>
      <el-table-column label="隔夜签到" min-width="120" align="right">
        <template #default="{ row }">{{ row.crossMoney }}</template>
      </el-table-column>
      <el-table-column label="合计课时费" min-width="130" align="right">
        <template #default="{ row }">{{ row.totalMoney }}</template>
      </el-table-column>


      <el-table-column label="银行卡号" min-width="130" align="right">
        <template #default="{ row }">{{ row.bankCardNumbers }}</template>
      </el-table-column>
      <el-table-column label="银行名称" min-width="130" align="right">
        <template #default="{ row }">{{ row.bankName }}</template>
      </el-table-column>
      <el-table-column label="银行网点" min-width="130" align="right">
        <template #default="{ row }">{{ row.branch }}</template>
      </el-table-column>
      <el-table-column label="手机号" min-width="130" align="right">
        <template #default="{ row }">{{ row.personagePhone }}</template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
          border
          layout="total, prev, pager, next"
          :current-page="query.page"
          :page-size="query.pageSize"
          :total="query.pageTotal"
          @current-change="handlePageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {selectCourseTypeRegion,} from "@/api/courseType";
import {getCoachMonthFeePage, exportCoachMonthFeeExcel} from "../../api/coach";
export default {
  name: "CoachMonthFee",
  data() {
    return {
      query: {
        regionId: null,
        page: 1,
        pageSize: 10,
        pageTotal: 0,
        year: 2026,
        month: 5,
        yearAndMonth: null
      },
      regionList:[],
      tableData: [],
      tableLoading: false,
    }
  },
  methods: {
    selectTableData() {
      this.tableLoading = true;
      //拆
      [this.query.year, this.query.month] = this.query.yearAndMonth ? this.query.yearAndMonth.split('-') : [null, null];
      getCoachMonthFeePage(this.query).then(val => {
        if (val.code == 200) {
          this.tableLoading = false;
          this.tableData = val.data.records;
          this.query.pageTotal = val.data.total;
        } else {
          this.$message.error("获取表格数据失败");
        }
      })
    },
    selectRegionByAreaId() {
      selectCourseTypeRegion().then(res => {
        if (res.code === 200) {
          this.regionList = res.data;
          if (res.data && res.data[0] && res.data[0].regionId) {
            this.query.regionId=res.data[0].regionId;
          }
          console.log(this.regionList)
          this.selectTableData();
        } else {
          this.$message.error("获取城市数据失败");
        }
      })
    },
    exportFile() {
      if(this.query.regionId == null){
        this.$message.error("请选择城市！");
        return;
      }
      [this.query.year, this.query.month] = this.query.yearAndMonth ? this.query.yearAndMonth.split('-') : [null, null];
      exportCoachMonthFeeExcel(this.query).then(val => {
        if (val.code == 200) {
          this.$message.success("下载中，请稍后前往右上角下载中心查看！");
        } else {
          this.$message.error(val.message);
        }
      });
    },
    //分页点击
    handlePageChange(val) {
      this.query.page = val;
      this.selectTableData();
    },
  },
  created() {
    this.selectRegionByAreaId();

  }
}
</script>

<style scoped>

</style>